import { type FileSystemNode, isDirectory, isFile } from "./fileSystemNode";

export function shouldUseZipExport(items: FileSystemNode[]): boolean {
  if (items.length === 0) {
    return false;
  }
  return items.some(isDirectory) || items.filter(isFile).length > 3;
}
